import React from 'react';
import classNames from 'classnames';
import { ENotificationEventType } from 'services/CrmApi/types/NotificationTypes';

interface INotificationTypeTagProps {
  type: ENotificationEventType;
}

export const NotificationTypeTag: React.FC<INotificationTypeTagProps> = ({ type }) => {
  const className = classNames(
    'notification-type-tag font-pt-sans text-[13px] rounded-[4px] p-[5px]',
    {
      'bg-yellow-advert-light text-status-requested': type === ENotificationEventType.BOOKING_REQUESTED,
      'bg-green-25 text-status-confirmed': type === ENotificationEventType.BOOKING_CONFIRMED,
      'bg-brown-prime-10 text-brown-prime': type === ENotificationEventType.USER_LOGIN_TA,
      'bg-blue-10 text-bright-sky-blue': type === ENotificationEventType.NEW_BASKET_ITEM,
    }
  );

  return (
    <div className={className}>
      {type === ENotificationEventType.BOOKING_REQUESTED && 'Booking Requested'}
      {type === ENotificationEventType.BOOKING_CONFIRMED && 'Booking Confirmed'}
      {type === ENotificationEventType.USER_LOGIN_TA && 'Travel Agent Login'}
      {type === ENotificationEventType.NEW_BASKET_ITEM && 'New Basket'}
    </div>
  );
};
